import { render, staticRenderFns } from "./WaypointsListMix.vue?vue&type=template&id=36621375&scoped=true"
import script from "./WaypointsListMix.vue?vue&type=script&lang=js"
export * from "./WaypointsListMix.vue?vue&type=script&lang=js"
import style0 from "./WaypointsListMix.vue?vue&type=style&index=0&id=36621375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36621375",
  null
  
)

export default component.exports